import type { ActionMode, CapabilityControlProps, FieldMode } from './types';

/** 字段 mode：显式 fieldModes 优先，否则继承 blockMode */
export function resolveFieldMode(fieldPath: string, control: CapabilityControlProps): FieldMode {
  if (control.fieldModes?.[fieldPath]) {
    return control.fieldModes[fieldPath];
  }
  if (control.blockMode === 'preview') {
    return 'readonly';
  }
  return 'editable';
}

/** 操作 mode：未声明默认 enabled */
export function resolveActionMode(actionKey: string, control: CapabilityControlProps): ActionMode {
  return control.actionModes?.[actionKey] ?? 'enabled';
}

export function isFieldVisible(fieldPath: string, control: CapabilityControlProps): boolean {
  return resolveFieldMode(fieldPath, control) !== 'hidden';
}

export function isActionVisible(actionKey: string, control: CapabilityControlProps): boolean {
  return resolveActionMode(actionKey, control) !== 'hidden';
}
